<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1 style="padding-bottom:10px;">About the Author</h1>
<p style="text-align: center;">Bridget was born in a thatched cottage to a beekeeper father and nature-loving mother. She grew up in the Welsh border town of Hay in the frugal</p>
<p style="text-align: center;">post-World War ll years. While campaigning against nuclear power stations in rural Northumberland, UK, she and her American husband raised four children.</p>
<p style="text-align: center;">In recent years, she has written local history books, been a teacher of English language to new citizens, promoted green energy schemes and</p>
<p style="text-align: center;">studied ancient woodlands.</p>
<p style="text-align: center;">She is a septuagenarian who can’t be stopped.</p><br/><br/><br/><br/><br/><br/>
<p style="text-align: center;">By the same author</p><br/>
<p style="text-align: center;"><strong>Bridget Gubbins’ Morpeth Local History series</strong>:</p>
<p style="text-align: center;"><em>de Merlay Dynasty, 2018</em></p>
<p style="text-align: center;"><em>The Conquest of Morpeth, 2017</em></p>
<p style="text-align: center;"><em>Juliana and Ranulph of Morpeth Castle, 2016</em></p>
<p style="text-align: center;"><em>Newminster: Monks, Shepherds and Charters, 2014</em></p>
<p style="text-align: center;"><em>The Mysteries of Morpeth’s Workhouse, 2013</em></p>
<p style="text-align: center;"><em>The Drovers are Coming to Morpeth Town, 2012</em></p>
<p style="text-align: center;"><em>The Curious Yards and Alleyways of Morpeth, 2011</em></p><br/>
<p style="text-align: center;"><em>Power at Bay, 1997</em></p>
<p style="text-align: center;"><em>Generating Pressure, 1991</em></p><br/>
<p style="text-align: center;"><em>Cover design by Stephen Ashton, Llansor Mill Press</em></p>
<p style="text-align: center;"><em>Rear cover painting with permission of Sue Jenkins</em></p>
<p style="text-align: center;"><em><br/>
</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?5c84dfad